import { useProductsSearchStore } from '../stores/productsSearchStore';

export const useProductsSearch = () => {
  const searchInput = useProductsSearchStore((state) => state.searchInput);
  const setSearchInput = useProductsSearchStore(
    (state) => state.setSearchInput
  );

  return { searchInput, setSearchInput };
};
